import { BMComponentsType } from "@traveloka/district-bloom";
import { MobileResources } from "../../../core/resource/MobileResourceProvider";
import { CurrencyValue, formatCurrency } from "../../../utils";
import { BalanceStatus } from "./types";

export function createBalanceIndicatorSpecs(
  status: BalanceStatus | undefined,
  amount: CurrencyValue | undefined,
  cr: MobileResources["content"]["CorporateEnumCreditLimit"],
  BMComponents: BMComponentsType
) {
  const defaultText = amount ? formatCurrency(amount) : "-";
  switch (status) {
    case "CONTRACT_EXPIRED":
    case "SUSPENDED":
      return {
        color: BMComponents.BMStyleTextInkSecondary,
        text: "-",
      };
    case "SUFFICIENT":
      return {
        color: BMComponents.BMStyleIconInkHighlightGreen,
        text: amount ? formatCurrency(amount) : cr.SUFFICIENT,
      };
    case "LOW":
      return {
        color: BMComponents.BMStyleIconInkHighlightYellow,
        text: amount ? formatCurrency(amount) : cr.LOW,
      };
    case "VERY_LOW":
      return {
        color: amount
          ? BMComponents.BMStyleIconInkHighlightRed
          : BMComponents.BMStyleIconInkHighlightYellow,
        text: amount ? formatCurrency(amount) : cr.LOW,
      };
    case "EMPTY":
      return {
        color: BMComponents.BMStyleIconInkSecondary,
        text: amount ? formatCurrency(amount) : cr.EMPTY,
      };
    case "MINUS":
      return {
        color: amount
          ? BMComponents.BMStyleIconInkPrimary
          : BMComponents.BMStyleIconInkSecondary,
        text: amount ? formatCurrency(amount) : cr.EMPTY,
      };
    default:
      return {
        color: BMComponents.BMStyleTextInkSecondary,
        text: defaultText,
      };
  }
}
